export function isImageValid(src) {
  return new Promise(function (resolve) {
    var img = document.createElement('img');
    img.onerror = function () {
      return resolve(false);
    };
    img.onload = function () {
      return resolve(true);
    };
    img.src = src;
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-image/es/util.js
// module id = 3862
// module chunks = 0